import { ReactSVG } from "react-svg";
import UsersSearch from "../Search";

const UsersFilters = ({
    search,
    setSearch,
    role,
    setRole,
    sort,
    setSort
}) => {
    return (
        <div className="bg-white p-5 rounded-xl shadow-lg space-y-5 border border-gray-100">

            {/* Search */}
            <UsersSearch value={search} onChange={setSearch} />

            {/* Filters */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                {/* Role */}
                <div className="flex flex-col space-y-1">
                    <label className="text-xs text-gray-500 flex items-center gap-1">
                   
                        <ReactSVG src={`${process.env.PUBLIC_URL}/assets/images/icons/position.svg`} className="w-5 h-5"/>

                        نقش کاربر
                   
                    </label>

                    <div className="relative">
                        <select
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            className="
                                w-full px-4 py-2.5 rounded-lg border bg-gray-50
                                text-gray-700 text-sm
                                focus:ring-2 focus:ring-purple-400 outline-none
                                hover:bg-gray-100 transition
                            "
                        >
                            <option value="all">همه نقش‌ها</option>
                            <option value="user">کاربر</option>
                            <option value="admin">ادمین</option>
                            <option value="staff">کارکن</option>
                        </select>
                    </div>
                </div>

                {/* Sort */}
                <div className="flex flex-col space-y-1">
                    <label className="text-xs text-gray-500 flex items-center gap-1">
                    
                        <ReactSVG src={`${process.env.PUBLIC_URL}/assets/images/icons/events.svg`} className="w-5 h-5"/>
                    
                        مرتب‌سازی تاریخ
                    
                    </label>

                    <div className="relative">
                        <select
                            value={sort}
                            onChange={(e) => setSort(e.target.value)}
                            className="
                                w-full px-4 py-2.5 rounded-lg border bg-gray-50
                                text-gray-700 text-sm
                                focus:ring-2 focus:ring-purple-400 outline-none
                                hover:bg-gray-100 transition
                            "
                        >
                            <option value="newest">جدیدترین‌ها</option>
                            <option value="oldest">قدیمی‌ترین‌ها</option>
                        </select>
                    </div>
                </div>

            </div>

        </div>
    );
};

export default UsersFilters;
